<!--
@Author: Colin Osterhout <ctosterhout>
@Date:   2019-09-14T15:26:04-08:00
@Email:  ctosterhout@alaska.edu
@Project: ernie
@Last modified by:   ctosterhout
@Last modified time: 2020-01-20T10:22:38-09:00
@License: Released under MIT License. Copyright 2019 University of Alaska Southeast.  For more details, see https://opensource.org/licenses/MIT
-->

<template>
  <section class="page-masthead position-relative"
               aria-label="Masthead"
               :style="`background-image: url('${randomImageUrl}');`">
    <div class="d-none d-md-block position-absolute w-100"
         style="bottom: 1rem;">
        <div v-if="urlTagline" class="container">
            <img :style="taglineStyle" :src="urlTagline" alt="Tagline"/>
        </div>
    </div>
  </section>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.page-masthead {
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}
</style>

<script>

import _ from 'lodash'

export default {
  name: 'RandomMastheadImage',
  props: {
    images: {
      type: [ Object, Array ],
      required: true
    },
    urlTagline: {
      type: String,
      required: false
    },
    taglineStyle: {
      type: String,
      required: false,
      default: 'height: 125px'
    }
  },
  computed: {
    randomImageUrl: function () {
      return _.sample(this.imageDescriptors).path
    }
  },
  data: function () {
    return {
      imageDescriptors: []
    }
  },
  created: function () {
    // The CMS exports the "images" attribute as an object which contains a single Array member with name of 'image'.
    this.imageDescriptors = _.isArray(this.images)
      ? this.images
      : _.isObject(this.images.images) && !_.isUndefined(this.images.images.image)
        ? _.flatten([this.images.images.image])
        : undefined
  },
  methods: {},
  components: {}
}
</script>
